import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { strpLocalize } from "../localization/localize";
import { addQueryParams, postMessageToParent } from "../utils/utils";
import { postSessionData, postDemographics } from "../redux/actions";
import { trackPage } from "../analytics";
import { dispatchEventSurveyCompleted } from "../events";

const mapStateToProps = (state) => {
  return { 
    survey: state.survey, 
    sessionId: state.sessionId, 
    conditions: state.conditions 
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    postDemographics: (surveyId, sessionId, successCb, confirmContinueCb) => {
      dispatch(postDemographics(surveyId, sessionId, successCb, confirmContinueCb))
    },
    postSessionData: (surveyId, sessionId, data, cb) =>
      dispatch(postSessionData(surveyId, sessionId, data, cb)),
  };
};

function getURL(props) {
  var redirectUrl = props.survey.completionLink;

  if (
    props.match.params.surveyId === "603831cadbcea0ab8733af2e" &&
    props.location.search &&
    props.location.search.includes("panel=Cint")
  )
    redirectUrl =
      "https://s.cint.com/Survey/Complete?ProjectToken=6e608293-0547-4509-a177-f5f9b73f1607";

  return addQueryParams(
    strpLocalize(redirectUrl),
    {
      phonicSessionId: props.sessionId,
    },
    props.location.search
  );
};

function postSessionDemographics(props) {
  const finishSession = () => {
    const completeAndRedirect = () => {
      const { conditions } = props;
      if (conditions && conditions.truexSessionId) postMessageToParent("interaction::phonic_survey_complete");
      if (props.survey.redirectToCompletionLink && !props.continuePopupOpen) {
        window.location.href = getURL(props);
      }
    }

    props.postSessionData(
      props.match.params.surveyId,
      props.sessionId,
      { completionStatus: "FINISHED" },
      completeAndRedirect
    );
  }

  props.postDemographics(
    props.survey._id,
    props.sessionId,
    finishSession,
    finishSession,
  )
  
}

class Finished extends Component {
  constructor(props) {
    super(props);
    postSessionDemographics(props);
  }

  componentDidMount() {
    dispatchEventSurveyCompleted();
    trackPage("Finished", {
      sessionId: this.props.sessionId,
      surveyId: this.props.match.params.surveyId,
    });
  }

  getTitle = () => {
    if (this.props.survey) {
      if (this.props.survey.finishedTitle)
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: strpLocalize(this.props.survey.finishedTitle),
            }}
          />
        );

      if (this.props.survey.completionLink)
        return strpLocalize("You're Almost Done!");
    }
    return strpLocalize("You're Done!");
  };

  getSubTitle = () => {
    if (this.props.survey && this.props.survey.completionLink) {
      return (
        <div>
          {strpLocalize(
            this.props.survey.finishedSubTitle
              ? this.props.survey.finishedSubTitle
              : "Follow this link to complete your response"
          )}
          <br />
          <a href={getURL(this.props)}>
            {strpLocalize(this.props.survey.completionLink)}
          </a>
        </div>
      );
    }
    if (this.props.survey && this.props.survey.finishedSubTitle) {
      return <div>{this.props.survey.finishedSubTitle}</div>;
    }
    return (
      <div>
        {strpLocalize("Thank you for your responses. You can close this tab.")}
      </div>
    );
  };

  render() {
    return (
      <>
        <div>
          <Typography variant="h1" className="title">
            {this.getTitle()}
          </Typography>
          <h2 className="subtitle">{this.getSubTitle()}</h2>
        </div>
        <div style={{ marginTop: 30 }} />
      </>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Finished)
);
